// extracted by mini-css-extract-plugin
export var active = "_bd-7";
export var blink = "_bd-8";
export var dropDownSelector = "_bd-4";
export var dropDownWrapper = "_bd-3";
export var fakeCursor = "_bd-6";
export var fontSizeButton = "_bd-9";
export var formQuillEditor = "_bd-0";
export var pressed = "_bd-a";
export var qlBlank = "_bd-1";
export var textFormattingToolbar = "_bd-2";
export var textToolbarOption = "_bd-5";